<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "VRRoad",
        icon: require("@/assets/images/digitalImg/vrroad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/vrroad_icon.png"),
          title: "VRRoad：在道路设计方案中身临其境",
          subTitle: "道路驾驶模拟与安全评价系统",
          downloadBtnList: [
            {
              label: "下载客户端",
              otherLabel: "下载客户端",
              fileUrl: "",
              fileName: "VRRoad",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_vrroad.png"),
          videoUrl: `${prefix}/static/video/VRRoad_cn.mp4`,
        },
        all: {
          title: "什么是 VRRoad？",
          content:
            "道路驾驶模拟与安全评价系统VRRoad，是面向道路几何设计及安全性评价的软、硬件集成解决方案。系统可快速导入设计成果，并参照OpenDrive标准生成精确描述车道及道路沿线特征的模拟路网，自带微观级背景交通流仿真模块，实现信息完备的实验数据同步采集，支持多自由度运动平台驱动，提供逼真的驾驶体感。",
          imgLists: [
            {
              id: 1,
              title: "沉浸式3D场景（1/3）",
              img: require("@/assets/images/digitalImg/vrroad_img1.png"),
            },
            {
              id: 2,
              title: "逼真的动态体感（2/3）",
              img: require("@/assets/images/digitalImg/vrroad_img2.png"),
            },
            {
              id: 3,
              title: "完备的行车数据（3/3）",
              img: require("@/assets/images/digitalImg/vrroad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "为什么选择 VRRoad？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/vrroad_icon1.png"),
              title: "逼真的驾驶仿真体验",
              content:
                "多自由度运动平台，用于与车辆动力学模型数据实时交互，提供逼真的动态体感。",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/vrroad_icon2.png"),
              title: "完备的行车数据",
              content:
                "动态、交互式可视化数据分析，显著提高数据分析效率，易于实现数据清洗、切片和批量计算。",
            },
          ],
        },
        function: {
          title: "VRRoad 的功能！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/vrroad_function01.png"),
              title: "改善道路设计方案",
              content: [
                "VRRoad可提供信息完备的驾驶行为数据，设计者通过数据分析，可以更加科学、精准地评估设计方案的合理性，减少设计中的漏洞和不足。",
              ],
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/vrroad_function02.png"),
              title: "提升安全防控水平",
              content: [
                "VRRoad为长大下坡、连续弯道等事故易发路段的研究提供安全、低成本的实验环境，帮助设计者探索风险致因，助力安全防控升级。",
              ],
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/vrroad_function03.png"),
              title: "优化交通组织",
              content: [
                "VRRoad可应用于交叉口渠化、高速公路改扩建施工期交通组织设计等领域。辅助设计方案比选、优化，助力瓶颈路段通行能力提升。",
              ],
            },
            {
              id: 4,
              img: require("@/assets/images/digitalImg/vrroad_function04.png"),
              title: "技术支持",
              content: [
                "VRRoad以支撑公路、城市道路、桥梁、隧道、交通安全设施等的参数化三维模型重构，具有1：1还原设计图的能力，保障了仿真场景的精确性。VRRoad研发团队有多年驾驶模拟、交通安全相关技术的研究经验，对驾驶模拟技术的细节、痛点有准确把握。",
              ],
            },
          ],
        },
        support: {
          title: "VRRoad的用户支持",
          documnentUrl: "/download?anchor=manual",
          videosUrl: "/academy?anchor=VRRoad",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/vrroad_contactbg.png"),
          title: "立即获取VRRoad！",
          subTitle: "狄诺尼数字设计软件产品线，为您带来一站式设计解决方案",
          downLoadBtnText: "下载产品手册",
          downLoadBtnUrl: "/download?anchor=manual",
          contactBtnText: "让销售人员联系您",
          contactBtnUrl: "",
        },
        combination: {
          title: "使用其他软件配合 VRRoad 进行工作！ ",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/vrroad_combination01.png"),
              title: "使用VRRoad",
              subTitle: "完成“喀喇昆仑公路”驾驶模拟",
              content:
                "- 设计、仿真一体化软件带你在虚拟世界里领略喀喇昆仑公路的魅力",
              caseUrl: "",
            },
          ],
          softwares: [
            {
              name: "AIRoad",
              icon: require("@/assets/images/digitalImg/airoad_icon3.png"),
              desc: "依托自主研发的BIM引擎，基于GIS、航测遥感等数据构建数字化地形，通过动态交互式布线，自动构建方案模型。",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "3" }).then((res) => {
        // console.log(res);
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
